export let AccordionPanelCssVars = /*#__PURE__*/function (AccordionPanelCssVars) {
  AccordionPanelCssVars["accordionPanelHeight"] = "--accordion-panel-height";
  AccordionPanelCssVars["accordionPanelWidth"] = "--accordion-panel-width";
  return AccordionPanelCssVars;
}({});